/** F606 Follows page — trainer ↔ trainee follow graph. */
import { Heart } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606FollowsPage() {
  return (
    <F606DataPage
      entity="follows"
      titleAr="المتابعات"
      titleEn="Follows"
      icon={Heart}
      emptyIcon={Heart}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        { key: 'follower_name', ar: 'المتابِع', en: 'Follower', render: (r) => <span className="font-bold text-white">{r.follower_name || '—'}</span> },
        {
          key: '_arrow',
          ar: '→', en: '→',
          render: () => <span className="text-white/30">→</span>,
          className: 'w-8 text-center',
        },
        { key: 'target_name', ar: 'يتابع', en: 'Follows', render: (r) => r.target_name || r.followed_name || '—' },
        { key: 'target_type', ar: 'النوع', en: 'Type', render: (r) => r.target_type || 'trainer', className: 'w-24 text-[10px] text-white/60' },
        {
          key: 'created_at',
          ar: 'منذ', en: 'Since',
          render: (r) => r.created_at ? new Date(r.created_at).toLocaleDateString() : '—',
          className: 'w-28 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
